/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcChevronLeftLargeRegular({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M15.637 3.364a.9.9 0 0 1 0 1.272L8.273 12l7.364 7.364a.9.9 0 1 1-1.273 1.273l-8-8a.9.9 0 0 1 0-1.273l8-8a.9.9 0 0 1 1.273 0"
        clipRule="evenodd"
      />
    </svg>
  );
}
export default IcChevronLeftLargeRegular;
